import React from "react";
import LegalLayout from "./LegalLayout";

export default function Responsible() {
    return (
        <LegalLayout
            title="Responsible Play"
            lastUpdated="February 17, 2026"
            path="/responsible-play"
        >
            <p>
                KickLoom is built for fans who enjoy football and want sharper
                data behind their picks. Betting can be entertaining — but it
                can also become a problem. We take that seriously and want you
                to as well.
            </p>

            <h2>The golden rules</h2>
            <ul>
                <li>
                    <strong>Only stake what you can afford to lose.</strong> If
                    losing the amount would impact your rent, groceries, family
                    or savings, it's too much.
                </li>
                <li>
                    <strong>Set a monthly budget.</strong> Decide what you can
                    spend before the month starts. When it's gone, it's gone.
                </li>
                <li>
                    <strong>Never chase losses.</strong> Doubling up after a
                    losing streak is the fastest way to make a small problem
                    into a big one.
                </li>
                <li>
                    <strong>Take breaks.</strong> If you're staking every day,
                    that's a yellow flag.
                </li>
                <li>
                    <strong>Don't bet drunk, tired, or upset.</strong> Your
                    decision-making is worse than you think it is.
                </li>
            </ul>

            <h2>Signs you might have a problem</h2>
            <ul>
                <li>You bet more than you planned to.</li>
                <li>You feel anxious when you're not betting.</li>
                <li>You hide your betting from people close to you.</li>
                <li>You borrow money to bet, or to pay back betting debt.</li>
                <li>You think "one big win" will fix things.</li>
            </ul>
            <p>
                If any of these sound familiar, please reach out for help. It's
                a medical issue, not a moral failure, and it is highly
                treatable.
            </p>

            <h2>Free help (by region)</h2>
            <ul>
                <li>
                    <strong>Nigeria</strong> — Lagos State Office of Mental Health Helpline:{" "}
                    <span className="font-mono text-primary">0809 932 1227</span>
                </li>
                <li>
                    <strong>UK</strong> — GamCare:{" "}
                    <span className="font-mono text-primary">0808 8020 133</span>{" "}
                    (24/7, free)
                </li>
                <li>
                    <strong>Ireland</strong> — Gamblers Anonymous:{" "}
                    <span className="font-mono text-primary">+353 1 872 1133</span>
                </li>
                <li>
                    <strong>USA</strong> — National Council on Problem Gambling:{" "}
                    <span className="font-mono text-primary">1-800-GAMBLER</span>
                </li>
                <li>
                    <strong>Worldwide</strong> — Gamblers Anonymous (find a meeting):{" "}
                    <a className="text-primary underline" href="https://www.gamblersanonymous.org">
                        gamblersanonymous.org
                    </a>
                </li>
            </ul>

            <h2>Self-exclusion</h2>
            <p>
                If you want to take time away from KickLoom, email{" "}
                <a className="text-primary underline" href="mailto:support@kickloom.com">
                    support@kickloom.com
                </a>{" "}
                with the subject "Self-exclude" and we will lock your account
                for a period you choose (30 days, 6 months, 1 year, or
                permanent). During the exclusion period you cannot log in or
                resubscribe.
            </p>

            <h2>A word about our predictions</h2>
            <p>
                Our model is good, not magic. Even our highest-confidence picks
                lose. The accumulator format inherently magnifies variance —
                a 10-game slip at high odds is exciting precisely because it is
                rarely going to land. Treat any single slip as entertainment,
                not as a paycheque.
            </p>

            <p className="text-zinc-400 text-sm italic">
                If you take only one thing from this page: play with money you
                can lose, and stop when it stops being fun.
            </p>
        </LegalLayout>
    );
}
